package one.healthium.onboarding.navigation.screenDefinition

import com.arkivanov.decompose.ComponentContext
import com.arkivanov.decompose.router.stack.ChildStack
import com.arkivanov.decompose.router.stack.StackNavigation
import com.arkivanov.decompose.router.stack.active
import com.arkivanov.decompose.router.stack.childStack
import com.arkivanov.decompose.router.stack.childStackWebNavigation
import com.arkivanov.decompose.router.stack.pop
import com.arkivanov.decompose.router.stack.pushNew
import com.arkivanov.decompose.router.webhistory.WebNavigation
import com.arkivanov.decompose.value.Value
import one.healthium.onboarding.domain.screens.ScreenDefinition
import one.healthium.onboarding.domain.screens.ScreensGroupModel

class DefaultScreenGroupComponent(
    componentContext: ComponentContext,
    override val screenGroup: ScreensGroupModel,
    private val onFinished: () -> Unit,
    private val onSignInClicked: () -> Unit,
) : ScreenGroupComponent, ComponentContext by componentContext {

    private val nav = StackNavigation<ScreenDefinition>()

    private val _stack = childStack(
        source = nav,
        serializer = ScreenDefinition.serializer(),
        initialStack = { listOf(screenGroup.screens.first()) },
        childFactory = ::child,
        handleBackButton = true,
    )

    private fun child(
        screenDefinition: ScreenDefinition,
        componentContext: ComponentContext
    ): ScreenGroupComponent.ScreenDefinitionChild {
        return ScreenGroupComponent.ScreenDefinitionChild(screenDefinition)
    }

    override val stack: Value<ChildStack<*, ScreenGroupComponent.ScreenDefinitionChild>> = _stack

    override val webNavigation: WebNavigation<*> =
        childStackWebNavigation(
            navigator = nav,
            stack = _stack,
            serializer = ScreenDefinition.serializer(),
        )

    override fun onBackClicked() {
        nav.pop()
    }

    override fun onSignInClicked() {
        onSignInClicked.invoke()
    }

    override fun onNextClicked() {
        val screens = screenGroup.screens
        val index = screens.indexOf(stack.active.instance.screenDefinition)
        if (index > -1 && index + 1 < screens.size) {
            nav.pushNew(screens[index + 1])
        } else {
            onFinished()
        }
    }
}